/**
 * @Author: chengzh
 * @Date:   2021-07-07 10:05:16
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-11 17:02:06
 */
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { Form } from 'antd';
import QueryString from 'query-string';
import _ from 'lodash';
import clsx from 'clsx';

const FormItem = Form.Item;
const FloatLabel = props => {
  const [focus, setFocus] = useState(false);
  const [labelClass, setLabelClass] = useState('');
  const styleObj = QueryString.parse(location.search);
  const {
    bolderColor,
    color,
    fontFamily,
    fontSize,
    fontSmoothing,
    fontWeight,
    floatLabelSize,
    floatLabelColor,
    floatLabelWeight,
  } = styleObj;
  // backgroundColor: '#f8f8f8',
  // bolderColor: '#f1f1f1',
  // color: '#666666',
  // fontWeight: 'bold',
  // fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
  // fontSize: '14px',
  // fontSmoothing: 'antialiased',
  // floatLabelSize: '12px',
  // floatLabelColor: '#333333',
  // floatLabelWeight: '100',
  const _bolderColor = bolderColor ? bolderColor : '#dddddd';
  const _color = color ? color : '#666666';
  const _fontFamily = fontFamily
    ? fontFamily
    : 'Roboto, Open Sans, Segoe UI, sans-serif';
  const _fontSize = fontSize ? fontSize : '14px';
  const _fontSmoothing = fontSmoothing ? fontSmoothing : 'auto';
  const _fontWeight = fontWeight ? fontWeight : 'normal';
  const _floatLabelSize = floatLabelSize ? floatLabelSize : '12px';
  const _floatLabelColor = floatLabelColor ? floatLabelColor : '#666666';
  const _floatLabelWeight = floatLabelWeight ? floatLabelWeight : 'bold';
  // nativeSelect 暂时提供给原生select使用,
  const {
    children,
    form,
    placeholder,
    nativeSelect,
    name,
    label,
    // rules,
    // style,
    floatclassname
  } = props || '';
  useEffect(() => {
    setLabelClassFn();
  }, []);
  useImperativeHandle(props.cref, () => ({
    // changeVal 就是暴露给父组件的方法
    setLabelClass: () => {
      setLabelClassFn();
    },
    setFormItemFocus: () => {
      onFocus()
    },
  }));
  const setLabelClassFn = () => {
    const myValue = form.getFieldValue(name);
    if (
      focus ||
      !_.isEmpty(myValue) ||
      !_.isEmpty(placeholder) ||
      nativeSelect
    ) {
      setLabelClass('h5-label-float');
    } else {
      setLabelClass('h5-label-normal');
    }
  };
  useEffect(() => {
    setLabelClassFn();
  }, [focus]);
  const onBlur = e => {
    setFocus(false);
  };
  const onFocus = e => {
    setFocus(true);
    const inputDom = document.getElementById(name);
    inputDom.focus();
    // positionAdjust();
  };

  const positionAdjust = () => {
    // 获取对应事件的 input dom
    const inputDom = document.getElementById(name);
    // const topDom = document.getElementById('__next');
    setTimeout(() => {
      // px to rem 的比例
      const rate =
        (window.screen.width || document.documentElement.clientWidth) / 375;
      // 底部按钮 375基准 的高度为 56，根据 rate 计算实际高度
      const bottomFixHeight = 56 * rate;

      // 高度计算
      const clientHeight = document.documentElement.clientHeight;
      const top = inputDom.getBoundingClientRect().top;
      const diff = clientHeight - top;
      // 当浏览器高度减上面的高度<300时候，说明元素在键盘下面，此时需要调整位置
      if (diff < 350) {
        inputDom.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'nearest',
        });
      }
    }, 200);
  };

  return (
    <div>
      <style jsx global>{`
        .h5pc-float-label-field input {
          border: 1px solid ${_bolderColor};
          font-family: ${_fontFamily};
          -webkit-font-smoothing: ${_fontSmoothing};
          -moz-osx-font-smoothing: ${_fontSmoothing};
        }
        .h5-label-normal label {
          font-size: ${_fontSize};
          color: ${_color};
          font-weight: ${_fontWeight};
        }
        .h5-label-float label {
          font-size: ${_floatLabelSize};
          color: ${_floatLabelColor};
          font-weight: ${_floatLabelWeight};
        }
      `}</style>
      <FormItem
        {...props}
        className={clsx('h5pc-float-label-field', labelClass, floatclassname ? floatclassname : '')}
        name={name}
        label={label}
        // rules={rules}
        // style={styleObj}
        onBlur={e => onBlur(e)}
        onFocus={e => onFocus(e)}
      >
        {children}
      </FormItem>
    </div>
  );
};

export default FloatLabel;
